import React from 'react';

import TextInput from '../components/TextInput';
import PrimaryButton from '../components/PrimaryButton';
import Logo from '../components/Logo';
import AppContext from '../context/AppContext';
import LoginContainer from '../containers/LoginContainer';

function Login({ history }) {
    return (
        <AppContext.Consumer>
            {({ updateAppState }) => (
                <LoginContainer
                    history={history}
                    updateAppState={updateAppState}
                    render={({ email, error, loading, handleEmailChange, onSubmit, redirectToRegistration }) => (
                        <div class='site-container--center'>
                            <form onSubmit={onSubmit} className='login'>
                                <Logo className='logo--start' />
                                <p className='register__paragraph'>
                                    Willkommen im Online-Banking der Theresienbank.
                                </p>
                                {error && error.code === 'auth/user-not-found' && (
                                    <>
                                        <p className='register__error'>
                                            Zu den eingegebenen Daten konnte kein Nutzer gefunden werden. Bitte registrieren Sie sich zunächst.<br/>
                                            <a href='/register' className='login__button'>
                                                Zur Registrierung &raquo;
                                            </a>
                                        </p>
                                   </>
                                )}  
                                <TextInput
                                    disabled={loading}
                                    value={email}
                                    onChange={handleEmailChange}
                                    description='E-Mail-Adresse'
                                    name='email'
                                    required
                                />
                                <PrimaryButton 
                                    loading={loading}
                                    title='Anmelden'
                                    type='submit'
                                />
                            </form>
                        </div>
                    )}
                />
            )}
        </AppContext.Consumer>
    )
}

export default Login;
